import React, { ReactNode, useContext, useEffect, useState } from 'react';

import { UtilityAccount } from '@totem/components/portfolio/buildings/details/utilities/types';
import UtilityAccountsContext from '@totem/components/portfolio/buildings/details/utilities/UtilityAccountsContext';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { BUILDINGS_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  buildingId: string;
  programId?: string;
  children?: ReactNode;
};

const UtilityAccountsContainer = ({
  buildingId,
  programId,
  children,
}: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<UtilityAccount[]>([]);
  const [refresh, setRefresh] = useState<boolean>(true);

  useEffect(() => {
    setRefresh(true);
  }, [buildingId, programId]);

  useEffect(() => {
    if (!refresh) {
      return;
    }

    setRefresh(false);

    setLoading(true);

    const params = new URLSearchParams();
    if (programId) {
      params.set('programId', programId);
    }

    const query = params.toString() ? `?${params.toString()}` : '';

    fetch(
      `${BUILDINGS_ENDPOINT}/${buildingId}/optimize/utility-accounts${query}`,
      {
        method: 'GET',
        headers: new Headers({
          Authorization: `Bearer ${getApiToken()}`,
        }),
      },
    )
      .then((res) => res.json())
      .then((result: UtilityAccount[]) => {
        setData(Array.isArray(result) ? result : []);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [refresh, buildingId, programId, getApiToken]);

  return (
    <UtilityAccountsContext.Provider
      value={{
        loading,
        data,
        buildingId,
        requestRefresh: () => setRefresh(true),
      }}
    >
      {children}
    </UtilityAccountsContext.Provider>
  );
};

export default UtilityAccountsContainer;
